const orderStatus = {
  pending: "Pending",
  cancelled: "Cancelled",
};
export { orderStatus };
